export default __webpack_public_path__ + "static/media/IMG_6760 - Copy (2).7bf9e394.jpg";